<template>
  <div class="side-bar-main">
    <ul class="nav-main">
      <li v-for="item in data" :key="item.id" class="nav-item" :item="item">
        <span class="text" :class="{'active': internalActiveMenu === item.name}" @click="navigation(item.id,item)">{{ item.name }}</span>
        <ul v-if="item.columnList" class="chidren-box">
          <li v-for="(chidren,index) in item.columnList" :key="index" class="chidren-item text" @click="goInterLink(chidren)">
            <a href="#">
              <span>{{ chidren.name }}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {

  props: {
    data: {
      type: Array,
      default: function() {
        return []
      }
    },
    activeMenu: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalActiveMenu: ''
    }
  },
  watch: {
    activeMenu: {
      handler(val) {
        if (val) this.internalActiveMenu = val;
      },
      immediate: true
    },
    data: {
      handler(val) {
        if (val && val.length > 0 && !this.internalActiveMenu) {
          this.internalActiveMenu = val[0].name;
        }
      },
      immediate: true
    }
  },
  methods: {
    navigation(id, item) {
      this.internalActiveMenu = item.name;
      try {
        if (id === 999) {
          this.$router.push({
            path: '/'
          })
        } else {
          // 文本导航
          if (item.navigationType) {
            if (item.jumpUrl) window.location.href = item.jumpUrl;
          } else {
            this.$router.push({
              path: '/subPage',
              query: {
                name: item.name
              }
            })
          }
        }
      } catch (error) {
        console.log('%c 🍌 error: ', 'font-size:20px;background-color: #E41A6A;color:#fff;', error);
      }
    },
    goInterLink({ columnType, id, name, href }) {
      if (href) {
        window.location.href = href
      } else if (columnType) {
        // 0 为单页 1: 列表
        this.$router.push({
          path: '/news',
          query: {
            columnName: name
          }
        })
      } else {
        this.$router.push({
          path: '/subPage',
          query: {
            name
          }
        })
      }
    }
  }
};
</script>

<style lang="less">
.side-bar-main {
  background: rgba(0, 30, 61, 0.6);
  height: 72px;
  position: absolute;
  bottom: 0;
  width: 100%;
  .nav-main {
    width: 1200px;
    margin: 0 auto;
    .nav-item {
      &:first-child{
        margin: 0;
      }
      &:last-child{
        margin: 0;
      }
      // margin-left:4.5px;
      // flex: 1;
      position: relative;
      display: inline-block;
      margin-right: 1px !important;
      flex: 0 0 auto;
      .text {
        display: inline-block;
        padding: 0 49px;
        white-space: nowrap;
        color: rgb(255, 255, 255);
        text-decoration: none;
        transition: background 0.2s;
        font-weight: bold;
        display: inline-block;
        font: 500 18px PingFang SC;
        line-height: 72px;
      }
      .text:hover,
      .text.active {
        background: #0060B5;
      }
      .chidren-box {
        display: none;
        list-style-type: none;
        position: absolute;
        z-index: 999;
        background: rgba(0, 0, 0, 0.6);
        min-width: 100%; /* 确保下拉框宽度 */
        left: 0;

        .chidren-item {
          position: relative;
          display: block;
          text-align: left;
          margin: 0;
          width: 100%;

          .text {
            white-space: nowrap;
            padding-left: 15px;
            padding-right: 15px;
            color: rgb(255, 255, 255);
            text-decoration: none;
            font-size: 16px;
            line-height: 50px;
            display: block; /* 改为 block 占满宽度 */
            width: 100%;
            box-sizing: border-box;
          }
        }
      }
      &:hover .chidren-box {
        display: block;
      }
    }
  }

  li {
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    color: #fff;
    font: normal 16px 微软雅黑, Arail, Verdana;
    text-decoration: none;
    line-height: 50px;
  }

  .background-color {
    color: #fff;
  }
}

@media screen and (min-width: 769px) {
  .side-bar-main {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
    .nav-main {
      max-width: 1200px;
      width: max-content;
      min-width: 100%;
      margin: 0 auto;
      display: flex;
      overflow: visible;
      white-space: nowrap;
      align-items: center;
      justify-content: center;
    }
    .nav-item {
      .text {
        padding: 0 24px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .side-bar-main {
    height: 40px;
    line-height: 40px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0, 30, 61, 0.8);
    transform: translateY(var(--headernav-overlap));
    z-index: 99;
  }

  .side-bar-main .nav-main {
    width: 100% !important;
    max-width: 100%;
    height: 40px;
    display: flex !important;
    align-items: center;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    flex-wrap: nowrap;
    touch-action: pan-x;
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    li {
      line-height: 40px !important;
    }

    /* Hide scrollbar */
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

    .nav-item {
      display: inline-block;
      margin: 1px !important;
      vertical-align: top;
      height: 40px;
      line-height: 40px !important;
      list-style: none;
      flex: 0 0 auto;

      .text {
        display: inline-block;
        height: 40px !important;
        line-height: 40px !important;
        padding: 0 15px !important;
        font-size: 12px;
        color: #fff;
        font-weight: bold;
        box-sizing: border-box;
        white-space: nowrap;
        overflow: visible;
      }

      .text:hover {
        background: transparent;
      }

      .text.active {
        background: #0060B5;
      }

      .chidren-box {
         display: none !important;
      }
    }
  }
}
</style>
